import {
    COLUMN_ACCESS,
    COLUMN_ACCESS_GROUPS_COUNT,
    COLUMN_CATEGORY,
    COLUMN_COMPANY,
    COLUMN_CREDENTIALS,
    COLUMN_DEPARTMENT,
    COLUMN_EMAIL,
    COLUMN_ENABLED,
    COLUMN_END_DATE,
    COLUMN_FIRST_NAME,
    COLUMN_GENDER,
    COLUMN_LAST_NAME,
    COLUMN_NAME,
    COLUMN_SECOND_NAME,
    COLUMN_SITE,
    COLUMN_SUFFIX,
    COLUMN_TITLE,
    COLUMN_UNIQUE_IDENTIFIER,
} from "../../constants/column-types";
import {
    FILTER_COMPANIES,
    FILTER_DEPARTMENTS,
    FILTER_SITES,
    FILTER_TAGHOLDER_TYPE,
    FILTER_TAGHOLDERS,
} from "../../constants/filter-types";
import LookupTypes from "../LookupTypes";
import { TableColumn } from "../table/TableColumn";

const EnrolmentColumns: TableColumn[] = [
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 0,
        sortByName: "mstTitle",
        sortDirection: "asc",
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE,
    },
    {
        heading: "Display Name",
        accessor: "name",
        isNumeric: false,
        id: 1,
        sortByName: "mstDisplayname",
        sortDirection: "asc",
        active: true,
        translationKey: "displayName",
        isDefault: true,
        columnId: COLUMN_NAME,
        lookupName: "mstDisplayname",
        searchOnName: "id",
        filterId: FILTER_TAGHOLDERS,
        settingDataName: 'master',
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 2,
        sortByName: "mstFirstname",
        sortDirection: "asc",
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME,
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 3,
        sortByName: "mstLastname",
        sortDirection: "asc",
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME,
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 4,
        sortByName: "mstMiddlename",
        sortDirection: "asc",
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME,
    },
    {
        heading: "Unique Identifier",
        accessor: "uid",
        isNumeric: true,
        id: 5,
        sortByName: "mstIdnumber",
        sortDirection: "asc",
        active: true,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    {
        heading: "Department",
        accessor: "deptName",
        isNumeric: false,
        id: 6,
        sortByName: "department.deptName",
        sortDirection: "asc",
        active: true,
        searchOnName: "department.id",
        lookupName: LookupTypes.department,
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: "department",
    },
    {
        heading: "Company",
        accessor: "companyName",
        isNumeric: false,
        id: 7,
        sortByName: "company.compName",
        sortDirection: "asc",
        active: true,
        searchOnName: "company.id",
        lookupName: LookupTypes.company,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: "company",
    },
    {
        heading: "Category",
        accessor: "category",
        isNumeric: false,
        id: 8,
        active: true,
        translationKey: "category",
        searchOnName: "profile.id",
        lookupName: "profile.id",
        columnId: COLUMN_CATEGORY,
        filterId: FILTER_TAGHOLDER_TYPE,
        settingDataName: "profile"
    },
    {
        heading: "Credentials",
        accessor: "totalTags",
        isNumeric: true,
        id: 9,
        active: true,
        translationKey: "credentials",
        columnId: COLUMN_CREDENTIALS,
    },
    {
        heading: "Access Groups",
        accessor: "totalAccessGroups",
        isNumeric: true,
        id: 10,
        active: false,
        translationKey: "accessGroups",
        columnId: COLUMN_ACCESS_GROUPS_COUNT,
    },
    {
        heading: "Email",
        accessor: "email",
        isNumeric: false,
        id: 13,
        // sortDirection: "asc",
        active: true,
        translationKey: "email",
        columnId: COLUMN_EMAIL,
    },
    {
        heading: "Gender",
        accessor: "genderLabel",
        isNumeric: false,
        id: 15,
        sortByName: "mstGender",
        active: false,
        translationKey: "gender",
        columnId: COLUMN_GENDER,
    }, // Leave out for now till we can manipulate the value.
    {
        heading: "Suffix",
        accessor: "suffix",
        isNumeric: false,
        id: 16,
        sortByName: "mstSuffix",
        active: false,
        translationKey: "suffix",
        columnId: COLUMN_SUFFIX,
    },
    {
        heading: "Enabled Credentials",
        accessor: "enableCredentialLabel",
        isNumeric: false,
        id: 17,
        sortByName: "mstCurrent",
        active: false,
        translationKey: "enableCredentials",
        columnId: COLUMN_ENABLED,
    },
    {
        heading: "Access Type",
        accessor: "masterType",
        isNumeric: false,
        id: 18,
        sortByName: "masterType.mtName",
        active: false,
        translationKey: "accessType",
        columnId: COLUMN_ACCESS,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 19,
        sortByName: "site",
        searchOnName: "site.id",
        sortDirection: "asc",
        lookupName: LookupTypes.site,
        active: true,
        translationKey: "site",
        filterId: FILTER_SITES,
        columnId: COLUMN_SITE,
        settingDataName: "site",
    },
];

export default EnrolmentColumns;
